import React from "react";
import { Link } from "react-router-dom";
// Import der Funktion für das Färben der InfoBoxes
import { usePalette } from "react-palette";

import "./SliderItemInfoBox.css";
import handleCharacterEncoding from "../../handleCharacterEncoding";
import AddToMyList from "../../Pages/Projectpage/VideoProjectPage/AddToMyList";
import LockImage from "../../img/svg/Lock.svg";
import FilmImage from "../../img/svg/Film.svg";
import CAImage from "../../img/svg/Animationszeichen.svg";
import TVImage from "../../img/svg/TV.svg";
import GameImage from "../../img/svg/Controller.svg";
import IMImage from "../../img/svg/IM.svg";
import TonImage from "../../img/svg/ton.svg";

import {
  ID_FILM,
  ID_TON,
  ID_VISUAL_EFFECTS,
  ID_COMPUTERANIMATION,
  ID_FERNSEHEN,
  ID_INTERAKTIVE_MEDIEN,
  MEDIENART_FILM_ANIMATION_VFX,
  MEDIENART_GAMES,
  MEDIENART_SOFTWAREENTWICKLUNG,
  MEDIENART_MOBILE,
} from "../../constants";

function InfoBox({
  boxHeight,
  title,
  displaycContentLockedMsg,
  projektID,
  semester,
  imgSrc,
  medienartID,
  stuproID,
  callbackFunction,
  placedOnListPage,
  infoBoxCallback,
}) {
  const { data } = usePalette(imgSrc);
  // InfoBox im Eingeloggten Zustand
  if (!displaycContentLockedMsg) {
    return (
      <div
        className="sl-new-info-box"
        style={{
          height: boxHeight,
          backgroundColor: data.muted,
          minHeight: "70px",
        }}
      >
        <Link
          style={{
            paddingTop: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
          to={`/mediathek/projectpage/${projektID}/details`}
          onClick={() => infoBoxCallback(projektID)}
        >
          <h2 className="sl-info-box-title">
            {handleCharacterEncoding(title)}
          </h2>
        </Link>
        <div className="sl-info-box-bottom">
          <h2 className="sl-info-box-semester">{semester}</h2>
          <div className="sl-bookmark-container">
            {defineStuPro(medienartID, stuproID)}
            <AddToMyList
              daten={projektID}
              callBack={() => callbackFunction()}
              onListPage={placedOnListPage}
            />
          </div>
        </div>
      </div>
    );
    // InfoBox im ausgeloggten Zustand bei gesperrtem Inhalt
  }
  if (displaycContentLockedMsg) {
    return (
      <div
        className="sl-new-info-box"
        style={{ height: boxHeight, minHeight: "70px" }}
      >
        <Link
          style={{
            paddingTop: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
          to={`/mediathek/projectpage/${projektID}/details`}
          onClick={() => infoBoxCallback(projektID)}
        >
          <h2 className="sl-info-box-title">{title}</h2>
        </Link>
        <div className="sl-info-box-bottom">
          <h2 className="sl-info-box-semester">{semester}</h2>
          <div className="sl-bookmark-container">
            <img
              className="sl-locked-icon"
              src={LockImage}
              alt="Gesperrter Inhalt"
            />
            {defineStuPro(medienartID, stuproID)}
            <AddToMyList
              daten={projektID}
              callBack={() => callbackFunction()}
              onListPage={placedOnListPage}
            />
          </div>
        </div>
        <div className="locked-content-info-wrapper" />
      </div>
    );
  }
  return null;
}

/* Für Stupro icons müssen projekt_medienart_id und am_studiotechnik_id in den
jeweiligen SQL/DTML abfragen hinzugefügt werden!!! */
function defineStuPro(medienart_id, stupro_id) {
  if (
    (stupro_id === ID_FILM || stupro_id === ID_VISUAL_EFFECTS) &&
    medienart_id === MEDIENART_FILM_ANIMATION_VFX
  ) {
    // film + vfx
    return (
      <img
        className="sl-stupro-icon"
        src={FilmImage}
        aria-label="Kategorie Film"
        alt="Kategorie Film"
      />
    );
  }
  if (
    stupro_id === ID_COMPUTERANIMATION &&
    medienart_id === MEDIENART_FILM_ANIMATION_VFX
  ) {
    // CA
    return (
      <img
        className="sl-stupro-icon"
        src={CAImage}
        aria-label="Kategorie Computeranimation"
        alt="Kategorie Computeranimation"
      />
    );
  }
  if (stupro_id === ID_FERNSEHEN) {
    // TV
    return (
      <img
        className="sl-stupro-icon"
        src={TVImage}
        aria-label="Kategorie TV"
        alt="Kategorie TV"
      />
    );
  }
  if (stupro_id === ID_TON) {
    // TV
    return (
      <img
        className="sl-stupro-icon"
        src={TonImage}
        aria-label="Kategorie TV"
        alt="Kategorie TV"
      />
    );
  }

  if (
    stupro_id === ID_INTERAKTIVE_MEDIEN &&
    medienart_id === MEDIENART_FILM_ANIMATION_VFX
  ) {
    // IM Filme
    return (
      <img
        className="sl-stupro-icon"
        src={IMImage}
        aria-label="Kategorie Interaktive Medien"
        alt="Kategorie Interaktive Medien"
      />
    );
  }
  if (
    // Games
    (stupro_id === ID_COMPUTERANIMATION &&
      medienart_id === MEDIENART_SOFTWAREENTWICKLUNG) ||
    (stupro_id === ID_COMPUTERANIMATION && medienart_id === MEDIENART_MOBILE) ||
    medienart_id === MEDIENART_GAMES
  ) {
    return (
      <img
        className="sl-stupro-icon"
        src={GameImage}
        aria-label="Kategorie Game"
        alt="Kategorie Game"
      />
    );
  }
  return (
    <img
      className="sl-stupro-icon"
      src={IMImage}
      aria-label="Kategorie Media"
      alt="Kategorie Media"
    />
  );
}

export default InfoBox;
